package com.zq.webproject

/**
 * JS平台实现
 */
class JsPlatform: Platform {
    override val name: String = "Web with Kotlin/JS"
}

actual fun getPlatform(): Platform = JsPlatform()
